import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f4bc4036")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("li", null, [
    _createVNode("a", {
      class: "link",
      href: _ctx.href,
      target: "_blank"
    }, [
      _createVNode("img", {
        class: "image",
        src: _ctx.src,
        alt: _ctx.alt
      }, null, 8, ["src", "alt"])
    ], 8, ["href"])
  ]))
})